export default {
  tasktags: [],
  pagination: {},
  contacts: [],
  paginationC: {},
  tasktag: {}
}
